/**
 * 用多個 .content 元素替換原 .content 元素（在 DOM 文檔中）
 */
export const replaceContentElementWithPages = (contentElement, pages, doc) => {
  const parent = contentElement.parentNode;
  const nextSibling = contentElement.nextSibling;
  
  // 創建新頁元素
  const newPages = pages.map(page => {
    const div = doc.createElement('div');
    div.className = 'content';
    div.innerHTML = page;
    return div;
  });
  
  // 移除原來的 .content 元素
  contentElement.parentNode.removeChild(contentElement);
  
  // 將新頁按順序插入
  let insertBeforeTarget = nextSibling;
  newPages.forEach(page => {
    if (insertBeforeTarget) {
      parent.insertBefore(page, insertBeforeTarget);
      insertBeforeTarget = page.nextSibling;
    } else {
      parent.appendChild(page);
      insertBeforeTarget = page.nextSibling;
    }
  });
};

